import Component from './Parameter.vue';

export default Component;
